// material-ui
import useMediaQuery from '@mui/material/useMediaQuery';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';

// project imports
import Search from './Search';
import Profile from './Profile';
import Notification from './Notification';
import MobileSection from './MobileSection';
import Logo from 'components/logo';

// admin
import UserImpersonationSelect from 'components/admin/UserImpersonationSelect';

// ==============================|| HEADER - CONTENT ||============================== //

export default function HeaderContent() {
  const downLG = useMediaQuery((theme) => theme.breakpoints.down('lg'));

  // ===== MOBILE HEADER =====
  if (downLG) {
    return (
      <>
        {/* Logo — absolutely centred against the full Toolbar width */}
        <Box
          sx={{
            position: 'absolute',
            left: '50%',
            transform: 'translateX(-50%)',
            display: 'flex',
            alignItems: 'center',
            pointerEvents: 'none'
          }}
        >
          <Logo sx={{ height: 32, maxWidth: 180, pointerEvents: 'auto' }} />
        </Box>

        {/* Spacer pushes bell + three dots to the right */}
        <Box sx={{ flex: '1 1 auto' }} />

        {/* Notification bell — always visible so badge + popups work on mobile */}
        <Notification />

        {/* Right-side mobile menu (3 dots) */}
        <MobileSection />
      </>
    );
  }

  // ===== DESKTOP HEADER =====
  return (
    <Box
      sx={{
        width: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between'
      }}
    >
      {/* LEFT SIDE */}
      <Box sx={{ flex: '1 1 auto', mr: 2 }}>
        <Search />
      </Box>

      {/* RIGHT SIDE */}
      <Stack
        direction="row"
        alignItems="center"
        spacing={2}
        sx={{
          flexShrink: 0,            // prevent clipping on the right
          maxWidth: 'fit-content',  // let content take natural width
        }}
      >
        <UserImpersonationSelect />

        <Notification />

        <Profile />
      </Stack>
    </Box>
  );
}
